import {Subject} from 'rxjs';

export enum PlaylistRestartReason {
    RECEIVED_MISSING_SCREEN,
    PLAYLIST_INDEX_MISMATCH,
}

export interface PlaylistRestartData {
    readonly reason: PlaylistRestartReason;
    readonly screenId: number;
}

export abstract class PlaylistSyncServiceBase {
    abstract readonly restartPlaylist: Subject<PlaylistRestartData>;

    abstract waitForScreenGroup(playlistIndex: number): Promise<void>;

    abstract cancelWaitForScreenGroup(reason?: string): void
}
